
export default {
  trainingManagerApi: {
    plan: {
      getList: '/api/trainingPlanApi/getList',
      exportList: '/api/trainingPlanApi/exportList',
      delPlans: '/api/trainingPlanApi/delPlans',
      saveOrUpdate: '/api/trainingPlanApi/saveOrUpdate',
      cancelPlan: '/api/trainingPlanApi/cancelPlan',
      uploadFiles: '/api/trainingPlanApi/uploadFiles',

    },
    result: {
      getList: '/api/trainingResultApi/getList',
      exportList: '/api/trainingResultApi/exportList',
      saveResult: '/api/trainingResultApi/saveResult',
      downloadTemplate: '/api/trainingResultApi/downloadTemp',
      uploadSignFiles: '/api/trainingResultApi/uploadSignFiles',
    },
    study: {
      rePushAccount: '/api/trainingStudyApi/rePushAccount',
      getBaseInfo: '/api/trainingStudyApi/getBaseInfo'
    }
  }
}